var _path, _rect, _rect2, _rect3, _rect4, _path2, _rect5, _rect6, _rect7, _rect8, _path3, _rect9, _rect10, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAgreementServiceBody2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.459 119.678L101.396 111.539C104.437 110.962 107.418 112.794 108.278 115.767L116.503 144.221C118.805 152.182 115.031 160.642 107.57 164.248L70.3202 182.251L58.459 119.678Z",
    fill: "#EEC2B9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.0825,
    y: 114.436,
    width: 80.2358,
    height: 13.4079,
    rx: 6,
    transform: "rotate(33.2866 53.0825 114.436)",
    fill: "#FFDCD5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7148,
    y: 125.637,
    width: 77.4373,
    height: 14.5252,
    rx: 6,
    transform: "rotate(33.2866 45.7148 125.637)",
    fill: "#FFDCD5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7344,
    y: 137.772,
    width: 71.3343,
    height: 13.4079,
    rx: 6,
    transform: "rotate(33.2866 37.7344 137.772)",
    fill: "#FFDCD5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3672,
    y: 148.974,
    width: 67.8747,
    height: 13.4079,
    rx: 6,
    transform: "rotate(33.2866 30.3672 148.974)",
    fill: "#FFDCD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4006 113.751C45.2638 110.921 49.0991 110.195 51.8685 112.147L77.9235 130.511C80.5716 132.377 81.2598 136.009 79.4781 138.715L55.4753 175.168C53.612 177.998 49.7768 178.725 47.0074 176.773L20.9523 158.409C18.3042 156.542 17.6161 152.911 19.3977 150.205L43.4006 113.751Z",
    fill: "#FFDCD5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43.4844,
    y: 164.155,
    width: 12.2906,
    height: 22.1237,
    rx: 4,
    transform: "rotate(33.0034 43.4844 164.155)",
    fill: "#EEC2B9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2529,
    y: 157.347,
    width: 12.2906,
    height: 17.8772,
    rx: 4,
    transform: "rotate(33.0034 33.2529 157.347)",
    fill: "#EEC2B9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 63.9473,
    y: 177.774,
    width: 12.2906,
    height: 16.1349,
    rx: 4,
    transform: "rotate(33.0034 63.9473 177.774)",
    fill: "#EEC2B9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 53.7153,
    y: 170.965,
    width: 12.2906,
    height: 19.1262,
    rx: 4,
    transform: "rotate(33.0034 53.7153 170.965)",
    fill: "#EEC2B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0968 120.313L85.3539 114.578L79 128.5L60.7474 131.752L53.9734 144.034C52.0373 147.545 47.8017 149.08 44.0658 147.626L43.5828 147.438C42.0317 146.834 41.2687 145.083 41.8827 143.536L49.151 125.222C50.1616 122.676 52.4051 120.824 55.0968 120.313Z",
    fill: "#EEC2B9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 98.9937,
    y: 102.462,
    width: 189.305,
    height: 64.597,
    rx: 4,
    transform: "rotate(-18.9457 98.9937 102.462)",
    fill: "#374969"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 24.5811,
    height: 64.597,
    rx: 4,
    transform: "matrix(-0.818407 -0.574639 -0.574639 0.818407 57.2373 108.849)",
    fill: "#F5F5F5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134.659,
    cy: 149.141,
    r: 3.38955,
    transform: "rotate(31.7203 134.659 149.141)",
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.947,
    cy: 145.665,
    r: 3.38955,
    transform: "rotate(31.7203 145.947 145.665)",
    fill: "#D9D9D9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAgreementServiceBody2);
export default __webpack_public_path__ + "static/media/IcAgreementServiceBody2.001eb09b41001f439986565275dda917.svg";
export { ForwardRef as ReactComponent };